export const PromotionAmountTypeEnum = [
    { id: 'flat', name: 'Flat' },
    { id: 'percent', name: 'Percent' }
];